import {
  calculateRefMapping,
  getDevice,
} from '@jobseeker/lotus/elements/donwAppHiristBanner';
import {AppState} from '@jobseeker/common-core/types';
import {getRefTagAndOrigin, handleTracking} from '@jobseeker/common-core/utils';
import {Box, Link, SxProps, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Image} from '@jobseeker/lotus/components/Image';

type HiristBannerProps = {
  children: React.ReactNode;
  sx?: SxProps;
  showLinkage?: boolean;
  bannerSx?: SxProps;
};

const HiristBannerComponent = ({
  children,
  sx,
  showLinkage,
  bannerSx,
}: HiristBannerProps) => {
  const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string>('');

    useEffect(() => {
      if (typeof navigator !== 'undefined') {
        setUserAgent(navigator.userAgent || navigator.vendor || '');
      }
    }, []);

    return userAgent;
  };
  const {
    profile: {subscriptions},
  } = useSelector((state: AppState) => state.user);
  const {isLoggedIn, userId} = useSelector((state: AppState) => state.auth);
  const userAgent = useUserAgent();

  const showPremium =
    !(
      subscriptions?.earlyApplicant.isValid ||
      subscriptions?.resumeBuilder.isValid
    ) && isLoggedIn;
  return (
    <Box
      sx={{
        backgroundImage: `url('https://job-static.hirist.com/V8/static/media/background-bg.ba8365c7.webp')`,
        backgroundRepeat: 'no-repeat',
        // backgroundSize: 'cover',
        bgcolor: '#13355c',
        px: {xxs: 2.5, md: 6},
        minHeight: {lg: '200px'},
        py: {xxs: 2.25, md: 4},
        borderBottomLeftRadius: {xxs: 10, md: 0},
        borderBottomRightRadius: {xxs: 10, md: 0},
        ...sx,
      }}
    >
      <Box display={'flex'}>{children}</Box>
      {showPremium && showLinkage && (
        <Box
          display="flex"
          alignItems="center"
          flex="1"
          flexBasis="100%"
          sx={{
            backgroundColor: '#fffaee',
            color: 'black',
            border: 'solid 1px #f0e2c3',
            borderRadius: '8px',
            maxWidth: 530,
            mt: 2,
            ml: {xxs: 0, md: '120px'},
            padding: 1,
            ...bannerSx,
          }}
        >
          <Box display="flex" alignItems="center" flex="1">
            <Image
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAiCAMAAAAnKQpfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTP//4f+/Kf/FLv+/KP/CLf+/KP+/Kf/AKf/KNv/AKf+/KP+/KP/AKv+/Kf+/Kf+/KP+/KP/BK/+/Kf+/KP+/Kf+/Kf++KAX0DW0AAAAXdFJOUwABqQ+/Gfv0PARS6uBEebRp8CnXyJSBRhWSlQAAAZRJREFUOMvFVduygyAMVJSLoIKg3f//0xOo9UCFzvSpOx2nQBI3mwS77tfgzBjGv3KZ+AbC9p2XBePcwrYt+kHrMma/Yei6AVtfcs7snATEIz+fhJhez/9IDwFI91xowDIBl8cccUzTgTHfcxDMAjot9mi/YM4NvIGUMD7fm7FEzz0tZOTfmfS8+Omons59Bpj03NIqQFGOokz6wEG/UhxBKiiEtFoxOx2wLXlYCe8h85cvG4J2M9YnFRupkIKZgCyWiIqVSZdMSLOXoPrYwVaBkV8WkjTw8orDR4iVYT/yNLkQXBkYFwmp8dRAUxwVyTo6UtGm7ApGXDmjIoed2s6c+S2GGnAPVFTLKXf21kpUJ2KibOQ9r5cAwzrThrAUpE91KrstPLd67snjUoT+DIp2+lfYEq+X91OjrdkpdtHptzTfprJ6XolUY1KTojlzdxlyKepohaQeHJuYG+Q5PqIuUy+gmgAaCZdz2N0nsIYA33Ly5+zdsccRrkOdV0PthtRTA7p5b7JP4rGGkzayCaN/8h36A5tNHYcT17qLAAAAAElFTkSuQmCC"
              alt="crown_img"
              width={36}
              height={24}
              style={{
                marginRight: '6px',
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: '400',
                  color: '#000',
                  opacity: 0.7,
                }}
              >
                Be an early applicant on jobs
              </Typography>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#000',
                  mt: 0,
                }}
              >
                Get notified as soon as a relevant job is posted{' '}
              </Typography>
            </Box>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            ml={'8px'}
          >
            <Link
              href={`/subscribe/plans?scrollTo=earlyApplicant&ref=topnavigation&source=${
                window.location.href.includes('/k/')
                  ? 'KeywordPage'
                  : 'CategoryPage'
              }&origin=categoryfeed`}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={{
                display: 'inline-block',
                textDecoration: 'none',
                width: '80px',
                height: '30px',
                borderRadius: '5px',
                backgroundColor: '#f5582d',
                padding: '8px 12px',
                mt: 0.5,
                '&:hover': {
                  backgroundColor: '#f5582d',
                },
              }}
              onClick={() => {
                const device = getDevice(userAgent);

                const {refText} = getRefTagAndOrigin();
                handleTracking('Subscription', {
                  event_category: 'jsClickEA_AppliedJob',
                  Origin: `${calculateRefMapping(refText)}`,
                  Device: device === 'ios' ? 'iOS' : 'Android',
                  Type: device === 'ios' ? 'iOS' : 'Android',
                  UserId: userId,
                  Status: isLoggedIn ? 'LoggedIn' : 'LoggedOut',
                });
              }}
            >
              <Typography
                sx={{fontSize: 11, fontWeight: 'bold', color: '#fff'}}
              >
                SEE HOW
              </Typography>
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HiristBannerComponent;
